export enum ClientFormStatus {
  NotStarted = 0,
  InProgress = 1,
  SubmittedForValidation = 2,
  SubmittedForApproval = 3,
  Completed = 4,
}
